import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FatalError from '../../error/FatalError';
import { isRouteChunkLoadError } from '../../../util/isRouteChunkLoadError';

/**
 * Catches failed route-chunk loads from `@loadable/component` and shows the
 * shared fatal-error recovery UI (reload + frontpage). Non-chunk errors are
 * re-thrown so outer boundaries (e.g. Sentry) can handle them.
 */
class RouteChunkErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;

    if (error) {
      if (!isRouteChunkLoadError(error)) {
        throw error;
      }

      return <FatalError />;
    }

    return this.props.children;
  }
}

RouteChunkErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default RouteChunkErrorBoundary;
